var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconHeaderHoverPricing = function SvgIconHeaderHoverPricing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#DA613A",
    d: "M5.3 15.467c0 .158.126.288.287.288h8.829c.158 0 .287-.13.287-.288v-1.05H5.3zM17.058 6.262a.29.29 0 0 0-.344.012l-3.797 3.018-2.666-4.908c-.097-.187-.402-.184-.502 0L7.083 9.292 3.287 6.274a.285.285 0 0 0-.342-.012.29.29 0 0 0-.112.325l2.359 7.255h9.62l2.355-7.255a.29.29 0 0 0-.109-.325"
  })));
};
export default SvgIconHeaderHoverPricing;